export default (type) => {
  let defaultValue;

  switch (type) {
    case "checkbox":
      defaultValue = false;
      break;
    case "dropdown":
      defaultValue = "";
      break;
    case "string":
      defaultValue = "";
      break;
    case "radio":
      defaultValue = "";
      break;
    case "list":
      defaultValue = [];
      break;
    default:
      defaultValue = "";
  }

  return defaultValue;
}